import { ActivitiesResponseTypeEnum, type ActivitiesResponseQuiz } from "@simbelapp/order-sdk";
import { QuizTypeEnum } from "~/utils/enums/activities.enums";
import { QUIZ_TYPE_META, newDraftId } from "~/utils/helpers/quiz.helpers";
import type { IActivityDraft } from "~/utils/interfaces/activities-interfaces";

/** A question the builder holds before its first save: orders gives it its quiz id then. */
export function draftQuiz(
  activityId: string,
  subType: QuizTypeEnum,
  fields: Partial<ActivitiesResponseQuiz> = {},
): ActivitiesResponseQuiz {
  return {
    activityId,
    quizId: "",
    subType,
    title: "",
    description: null,
    isScored: QUIZ_TYPE_META[subType].scored,
    answers: [],
    required: false,
    ...fields,
  };
}

/**
 * The "Question système" auto-added to every satisfaction survey: a "Note globale de satisfaction"
 * rated 1-10, required, and non-deletable. Its type and required flag are locked in the builder;
 * only its title/description/labels can be edited.
 */
export function createSystemQuestion(): IActivityDraft {
  const activityId = newDraftId();
  return {
    activityId,
    type: ActivitiesResponseTypeEnum.Quiz,
    title: null,
    quiz: draftQuiz(activityId, QuizTypeEnum.RATING, {
      title: "Quelle est votre satisfaction globale pour cette formation ?",
      description: "",
      required: true,
      isSystem: true,
      minLabel: "Pas du tout satisfait",
      maxLabel: "Très satisfait",
    }),
  };
}

/** What a builder card and panel show as an activité's title: a question's own, a support's. */
export const activityTitle = (activity: IActivityDraft): string =>
  (activity.type === ActivitiesResponseTypeEnum.Quiz ? activity.quiz?.title : activity.title) ?? "";

/** A freshly added activité, or a question whose format is not picked yet: the chooser shows. */
export const needsKind = (activity: IActivityDraft): boolean =>
  !activity.type || (activity.type === ActivitiesResponseTypeEnum.Quiz && !activity.quiz);
